import React from "react";
import { useTranslation } from "react-i18next";

function HelpCenter() {
  const { t } = useTranslation();

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="container py-5">
          <h2 className="text-center mb-4">{t('help_center')}</h2>
          <p className="text-center text-muted mb-5">
            {t('help_center-desc')}
          </p>
          <div className="row g-4">
            {/* Technical Support */}
            <div className="col-md-6">
              <div className="card help-card p-4">
                <h4>{t('technical_support')}</h4>
                <p>
                  {t('technical_support_desc')}
                </p>
                <ul className="list-unstyled">
                  <li>
                    <strong>{t('phone')}:</strong> +91 XXX-XXX-XXXX
                  </li>
                  <li>
                    <strong>{t('email')}:</strong> xyz@gmail.com
                  </li>
                </ul>
              </div>
            </div>
            {/* Event SOP Support */}
            <div className="col-md-6">
              <div className="card help-card p-4">
                <h4>{t('event_sop_support')}</h4>
                <p>
                  {t('event_sop_support_desc')}
                </p>
                <ul className="list-unstyled">
                  <li>
                    <strong>{t('phone')}:</strong> +91 XXX-XXX-XXXX
                  </li>
                  <li>
                    <strong>{t('email')}:</strong> xyz@gmail.com
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;
